/**
 * @file Created on Wed Aug 08 2018
 * @author BPo
 * @author PKl
 */
import CheckBox, { CheckBoxValidated } from './CheckBox';
export { CheckBoxValidated };
export default CheckBox;